// Generated by scripts/build-ui-icons.mjs.
export { FilePpt as default } from "../ui/glyphs-3";
